export const ROUTE_LOGIN_PATH = '/login';
export const ROUTE_SIGN_UP_PATH = '/signup';
export const ROUTE_SUBSCRIPTION_PATH = '/subscription';
export const ROUTE_COMMODITY_SELECTION_PATH = '/commodity-selection';
export const ROUTE_NOTIFICATION_PATH = '/notification';
export const ROUTE_DASHBOARD_PATH = '/dashboard';
export const ROUTE_HOME_PATH = '/home';
export const ROUTE_PROFILE_PATH = '/profile';
export const ROUTE_FORGOT_PASSWORD = '/forgot-password';
export const ROUTE_VIEW_REPORT = '/view-report';